var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophicAbiotic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.669 1.07a.191.191 0 0 0-.338 0L5.89 3.794a.191.191 0 0 1-.225.094L2.719 2.98a.191.191 0 0 0-.24.239l.909 2.946a.191.191 0 0 1-.094.225L.57 7.83a.191.191 0 0 0 0 .338L3.294 9.61c.081.043.12.138.094.225l-.908 2.946a.191.191 0 0 0 .239.24l2.946-.909a.191.191 0 0 1 .225.094L7.33 14.93a.191.191 0 0 0 .338 0l1.441-2.725a.191.191 0 0 1 .225-.094l2.946.908a.191.191 0 0 0 .24-.239l-.909-2.946a.191.191 0 0 1 .094-.225L14.43 8.17a.191.191 0 0 0 0-.338L11.706 6.39a.191.191 0 0 1-.094-.225l.908-2.946a.191.191 0 0 0-.239-.24l-2.946.909a.191.191 0 0 1-.225-.094L7.67 1.07ZM4.098 8a3.403 3.403 0 1 1 6.806 0 3.403 3.403 0 0 1-6.806 0ZM7.5 3.597a4.403 4.403 0 1 0 0 8.806 4.403 4.403 0 0 0 0-8.806Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophicAbiotic);
export default __webpack_public_path__ + "static/media/trophic-abiotic.44cb78f6687f33ef3a59311a0a3c4316.svg";
export { ForwardRef as ReactComponent };